import React from 'react';
import { Table, ButtonGroup, Button } from 'react-bootstrap';

const MessagesTable = ({ messages, onUpdate, onDuplicate, onRemove }) => {
    const rows = messages.map(({ id, title, body, icon, image, btn1Title, btn1Icon, btn2Title, btn2Icon }) => {
        return (
            <tr key={id}>
                <td>{id}</td>
                <td>{title}</td>
                <td>{body}</td>
                <td>{icon}</td>
                <td>{image}</td>
                <td>{btn1Title}</td>
                <td>{btn1Icon}</td>
                <td>{btn2Title}</td>
                <td>{btn2Icon}</td>
                <td>
                    <ButtonGroup>
                        <Button bsStyle="info" onClick={() => onUpdate(id)}>Update</Button>
                        <Button bsStyle="info" onClick={() => onDuplicate(id)}>Duplicate</Button>
                        <Button bsStyle="danger" onClick={() => onRemove(id)}>Remove</Button>
                    </ButtonGroup>
                </td>
            </tr>
        );
    });

    return (
        <Table bordered responsive>
            <thead>
            <tr>
                <th>ID</th>
                <th>Title</th>
                <th>Body</th>
                <th>Icon</th>
                <th>Image</th>
                <th>Button1 Title</th>
                <th>Button1 Icon</th>
                <th>Button2 Title</th>
                <th>Button2 Icon</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </Table>
    );
};

export default MessagesTable;


// WEBPACK FOOTER //
// ./src/scenes/ClickBaitMessages/components/MessagesTable/index.js